import React from 'react';
import { Card, Icon } from 'selfly-ui-react';

import { surchargeTypes, surgeValueType, appliedOn } from '../utils';

const ProductSurchargeCards = ({ surcharge, isAdmin, deleteSurcharge, editSurcharge, t }) => {
    const valueType = surgeValueType.find(value => value.type === surcharge.valueType);
    const surchargeAppliedOn = appliedOn.find(type => type.value === surcharge.appliedOn);
    const taxType = surchargeTypes.find(tax => tax.type === surcharge.surchargeType);

    return (
        <Card
            actions={
                isAdmin && [
                    {
                        label: <Icon>edit</Icon>,
                        onClick: () => editSurcharge(surcharge),
                    },
                    {
                        label: <Icon>delete</Icon>,
                        onClick: () => deleteSurcharge(surcharge),
                        type: 'negative',
                    },
                ]
            }
        >
            <h5>{surcharge.name}</h5>
            <div className="surcharges__contents-legends">
                <div className="surcharges__contents-type">
                    <span>{t(`surcharge:${taxType?.name}`)}</span>
                </div>
                <div>
                    <strong>{t('surcharge:taxValue')}:</strong> {surcharge.value} <span>| {t(`surcharge:${valueType?.name}`)}</span>
                </div>

                <div className="surcharges__contents-applied">
                    <svg className="surcharges__contents-icon">
                        <use xlinkHref="#icon-price-tag"></use>
                    </svg>
                    <span>
                        <strong>{t('surcharge:appliedOn')} : </strong>
                    </span>
                    <span>{t(`surcharge:${surchargeAppliedOn?.name}`)}</span>
                </div>
                {surcharge.externalCode && surcharge.externalCode ? (
                    <div>
                        <strong>{t('surcharge:externalCode')} :</strong> <span>{surcharge.externalCode} </span>
                    </div>
                ) : null}
            </div>
        </Card>
    );
};

export default ProductSurchargeCards;
